import { Dialog } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import Skeleton from "react-loading-skeleton";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ApiStatusTypeEnum } from "../../../../../../enumeration/ApiStatusTypeEnum";
import { CheckIsNull } from "../../../../../../utils/CommonHelper";
import * as actions from "../../../../redux/SettingAction";

export const DepositTelcoDialog = ({
  setSwalProps,
  companyCode,
  dismissBtnRef,
}) => {
  const dispatch = useDispatch();
  const formikRef = useRef();
  const receiptRef = useRef();
  const intl = useIntl();
  const navigate = useNavigate();
  const [depositToLastGame, setDepositToLastGame] = useState(false);
  const [selectedTelco, setSelectedTelco] = useState(0);
  const [selectedType, setSelectedType] = useState(0);
  const [open, setOpen] = useState(false);
  const newPaymentRef = useRef("");
  const newImgRef = useRef("");
  const settingState = useSelector(({ setting }) => setting, shallowEqual);

  useEffect(() => {
    dispatch(actions.getTelcoDepositUI());
    dispatch(actions.getDepositWalletUI()).then((resp) => {
      resp = resp.data;
      if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS)
        setDepositToLastGame(!CheckIsNull(resp.companycode));
    });
  }, []);

  const handleClose = () => {
    setOpen(false);
  };
  const handlNew = () => {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) {
      console.log(newPaymentRef.current);
    }

    window.open(`${newPaymentRef.current}&imageurl=${newImgRef.current}`);
    setOpen(false);
  };

  const saveValues = (queryParams) => {
    const pickedTelco = settingState.depositTelcoUI.telcoLists[selectedTelco];

    const newQueryParams = {
      telcocode: pickedTelco.telcocode,
      code: pickedTelco.telcoSupport[selectedType].code,
      type: pickedTelco.telcoSupport[selectedType].type,
      platform: "mobile",
      companycode: !CheckIsNull(companyCode)
        ? companyCode
        : depositToLastGame &&
          !CheckIsNull(settingState.depositWalletUI.companycode)
        ? settingState.depositWalletUI.companycode
        : "",
    };

    dispatch(actions.submitTelcoDepositRequest(newQueryParams)).then((resp) => {
      resp = resp.data;
      if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
        newPaymentRef.current = resp.paymentlink;
        newImgRef.current = resp.imageurl;
        handlNew();
        if (sessionStorage.getItem("platform") === "mobile") {
          const paymentLink = resp.paymentlink;
          console.log(`paymentTelco:${paymentLink}`);
          sessionStorage.setItem("paymentLink", paymentLink);
          // navigate("/setting/deposit/payment");
        }
        if (dismissBtnRef) {
          dismissBtnRef.current.click();
        }
      } else {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };

  return (
    <>
      {settingState.depositTelcoUI && settingState.depositWalletUI ? (
        settingState.depositTelcoUI.code === "0" &&
        settingState.depositWalletUI.code === "0" ? (
          <>
            <div className="text-input-label mb-2 text-font3">
              {intl.formatMessage({ id: "gateway" })}
            </div>
            <div className="d-flex mb-2 text-font2">
              {settingState.depositTelcoUI.telcoLists.map((telco, index) => (
                <div key={telco.telcocode} className="cursor-pointer me-4">
                  <div
                    onClick={() => {
                      setSelectedTelco(index);
                    }}
                  >
                    <div
                      className={`d-flex flex-column align-items-center menu-item`}
                      style={{
                        background:
                          selectedTelco === index ? "#f5be09" : "#2e323a",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      <div
                        style={{
                          color: selectedTelco === index ? "black" : "white",
                          textAlign: "center",
                        }}
                      >
                        {telco.telconame}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="text-input-label mb-2 text-font3">
              {intl.formatMessage({ id: "chooseATelco" })}
            </div>
            <div className="row">
              {settingState.depositTelcoUI.telcoLists[
                selectedTelco
              ].telcoSupport.map((telco, index) => (
                <div
                  key={telco.code}
                  className="col-md-3 mb-2"
                  style={{ width: "50%", margin: "0 auto", color: "white" }}
                >
                  <div
                    className={`card cursor-pointer ${
                      selectedType === index ? "bank-active" : ""
                    }`}
                    style={{
                      color: selectedType === index ? "#f5be09" : "white",
                      background: "#1c1e23",
                    }}
                  >
                    <div
                      className="card-body"
                      style={{ background: "rgba(0,0,0,0.2)" }}
                      onClick={() => {
                        setSelectedType(index);
                      }}
                    >
                      <div
                        className={`d-flex flex-column align-items-center menu-item ${
                          selectedType === index ? "show fw-bold" : ""
                        }`}
                      >
                        <img
                          src={telco.imageurl}
                          alt={telco.name}
                          style={{ width: "100px" }}
                        />
                        <div
                          className="d-flex align-items-center justify-content-center small"
                          style={{ height: "40px" }}
                        >
                          <div className="text-center text-font2">
                            {telco.name}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {settingState.depositWalletUI &&
              CheckIsNull(companyCode) &&
              !CheckIsNull(settingState.depositWalletUI.content) && (
                <div className="form-check text-font2">
                  <input
                    className="form-check-input"
                    id="depositWalletUI"
                    type="checkbox"
                    checked={depositToLastGame}
                    onChange={(e) => {
                      setDepositToLastGame(e.target.checked);
                    }}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="depositWalletUI"
                    dangerouslySetInnerHTML={{
                      __html: settingState.depositWalletUI.content.replace(
                        /\*(.*?)\*/g,
                        "<span class='text-danger fw-bold text-font3'>$1</span>"
                      ),
                    }}
                  />
                </div>
              )}
            <button
              type="button"
              disabled={settingState.actionsLoading}
              style={{ color: "black", backgroundColor: "#f5be09" }}
              className="btn btn-prim fw-bold px-3 w-100 mb-4 mt-2"
              onClick={() =>
                setSwalProps({
                  show: true,
                  icon: "info",
                  title: intl.formatMessage({ id: "alert" }),
                  showCancelButton: true,
                  showConfirmButton: true,
                  confirmButtonText: intl.formatMessage({ id: "confirm" }),
                  denyButtonText: intl.formatMessage({ id: "cancel" }),
                  html: `
                <p>${intl.formatMessage({ id: "openNewTab4" })}</p>
                <div class="d-flex">
                  <i class="bi bi-dot"></i>
                  <div>${intl.formatMessage({ id: "openNewTab5" })}</div>
                </div>
                <div class="d-flex">
                  <i class="bi bi-dot"></i>
                  <div>${intl.formatMessage({ id: "openNewTab6" })}</div>
                </div>
              `,
                  onConfirm: () => {
                    saveValues();
                  },
                })
              }
            >
              <div className="d-flex align-items-center justify-content-center text-font3">
                {settingState.actionsLoading && (
                  <div
                    className="spinner-border text-dark"
                    role="status"
                    style={{ scale: "0.75" }}
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                )}
                {intl.formatMessage({ id: "submit" })}
              </div>
            </button>
            <Dialog open={open} onClose={handleClose}>
              <div
                className="text-font3"
                style={{
                  padding: "20px",
                  backgroundColor: "#1c1e23",
                  color: "white",
                }}
              >
                <div>
                  <i
                    className="bi bi-exclamation-circle"
                    style={{ width: "30px", height: "30px" }}
                  />
                </div>

                <p> {intl.formatMessage({ id: "openNewTab4" })}</p>
                <div className="mb-1 d-flex">
                  <i className="bi bi-dot"></i>
                  <div>{intl.formatMessage({ id: "openNewTab5" })}</div>
                </div>
                <div className="mb-1 d-flex">
                  <i className="bi bi-dot"></i>
                  <div>{intl.formatMessage({ id: "openNewTab6" })}</div>
                </div>
                <div
                  className="d-flex mt-3"
                  style={{ justifyContent: "space-evenly" }}
                >
                  <div
                    style={{ color: "#f5be09" }}
                    onClick={() => saveValues()}
                  >
                    {intl.formatMessage({ id: "confirm" })}
                  </div>
                  <div style={{ color: "red" }} onClick={() => setOpen(false)}>
                    {intl.formatMessage({ id: "cancel" })}
                  </div>
                </div>
              </div>
            </Dialog>
          </>
        ) : (
          <div style={{ height: "500px" }}>
            <div className="py-5 text-center">
              {settingState.depositTelcoUI.message}
            </div>
          </div>
        )
      ) : (
        <Skeleton className="w-100" height="500px" />
      )}
    </>
  );
};
